import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

export const RightPanelVerticalForm = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "right-panel-vertical-form",
})`
  width: 100%;
  background: white;
  padding: 20px 30px;
  label {
    display: block;
  }
  .idLabel {
    color: #1341d8;
  }
`;

export const ErrorBox = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "error-box",
})`
  width: 100%;
  background: white;
  padding: 20px 0;
  color: red;
`;
